// Actions
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import { FilterActions_fetchFilterFromUrlAndApi } from 'app/shared/flux/actions/FilterActions';

// Types
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';

// Define interfaces for better type safety
interface Trace {
  finishAsyncSpan: (params: { marker: string }) => void;
}

interface ReduxStore {
  getState: () => RootReduxState;
  dispatch: ThunkDispatch<RootReduxState, undefined, AnyAction>;
}

interface RouteState {
  pathname: string;
  query: Record<string, string | number | boolean | undefined>;
}

interface ReactContext {
  store: ReduxStore;
  trace: Trace;
  state: RouteState;
}

const loadFilterFromUrlAndApi = (reactContext: ReactContext): Promise<unknown> => {
  const { state, store, trace } = reactContext;
  const { pathname, query } = state;

  return store
    .dispatch(FilterActions_fetchFilterFromUrlAndApi(pathname, query))
    .then((response: unknown) => {
      trace.finishAsyncSpan({
        marker: 'FetchAreaWrapper#FilterActions_fetchFilterFromUrlAndApi',
      });

      return response;
    })
    .catch((error: Error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.areaPage.serverRouteWillMount#loadFilterFromUrlAndApi',
          errorClass: 'FilterActions',
        }),
      );
    });
};

export default loadFilterFromUrlAndApi;
